import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import HoverImage from "react-hover-image/build";
import {
  Button,
  Col,
  Input,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { dateFormate, currencyFormat, cellRendererCheck } from "utils/columns";
import Drawer from "components/Drawer";
import { Navigate } from "react-router-dom";
import { ModuleAccess } from "utils/moduleaccess";
import useAxios from "hooks/useAxios";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import Loader from "components/Loader";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import { forEach } from "lodash";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import edit from "assets/icon/edit-icon.svg";
import ViewSuuestions from "./ViewSuggestions";
import viewimage from "assets/icon/Viewsuggestions2.svg";
 import viewimagehover from "assets/icon/Viewsuggestions1.svg"
import { faL} from "@fortawesome/free-solid-svg-icons";

let showdata = [];
let EditData = [];
let rowForEdit = {};
let updatedFields = {};
const ReviewPurchaseOrderTable = (props) => {
  const {
    setkey,
    setData1,
    setDemoData,
    manvalConfigedit,
    manvalConfig,
    manvalPharmacy,
    onPageChange,
    totalitem,
    data,
    orgId,
    refetch,
    onReset,
    rowData,
    filters,
    tableresetFlag,
    searchTerms,
    collapseSider,
        toggleSider,
        resetFilterFlag,
    SetResetFilterFlag,
    onSearchColumnFilters = () => "",onExport,tabKey
  } = props;
  console.log(data,"data")
  const [tableData, setTableData] = useState([]);
  const [isConfirm, setisConfirm] = useState(false);
  const [isAuthorize, setisAuthorize] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openviewsugg, setOpenViewSugg] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  //const [modal, setModal] = useState(false);
  const [authorizemodal, setAuthorizeModal] = useState(false);
  const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
  const [drawerPODetails, setDrawerPODetails] = useState("");
  const [wacErr,setWACerr] = useState(false);
  const [gpoErr,setGPOerr] = useState(false);
  const [wacErrZero,setWACerrZero] = useState(false);
  const [gpoErrZero,setGPOerrZero] = useState(false);
  const [selectedrow,setSelectedRow] = useState({});

  useEffect(()=>{
     setOpenViewSugg(false)
     setisConfirm(false)
     setEditFlag(false)
     setData1([])
     setDemoData([])
     setisAuthorize(false)
  },[orgId])

  const checkvalidation = (selectedvaluesonly) => {
debugger;
    if ((selectedvaluesonly.wacPkgs == undefined || selectedvaluesonly.wacPkgs == null || selectedvaluesonly.wacPkgs == "") || (selectedvaluesonly.wacPkgs < 0) || (selectedvaluesonly.wacPkgs == 0)) {
      setWACerr(true);
      return true;
    }
    if ((selectedvaluesonly.gpoPkgs == undefined || selectedvaluesonly.gpoPkgs == null || selectedvaluesonly.gpoPkgs == "") || (selectedvaluesonly.gpoPkgs < 0) || (selectedvaluesonly.gpoPkgs == 0)) {
      setGPOerr(true);
      return true;
    }
    else {
      return false;
    }
  }
  //const navigate = useNavigate();
  const API = useAxios();
  // useEffect(() => {
  //   setTableData([])
  //   showdata= [];
  //   for (var x in data) {
  //     if (x > "0") {
  //       showdata.push(data[x]);
  //       setTableData(showdata);
  //     }
  //   }
  // }, [data]);
  useEffect(()=>{
    setTableData(data)
  },[data])
  useEffect(() => {
    setTableData([]);
  }, [tableresetFlag]);
  const togglePODetailsDrawer = () => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails("");
  };
  const handleConfig = async (rowData) => {
    await manvalConfig();
  };
  const handelAddCoveredEntity = async (rowData) => {
    await manvalPharmacy();
  };
  const handleEditConfig = async () => {
    await manvalConfigedit();
  };
  const renderEditButton = () => {
     if (hasPermission('ED'))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => handleEditConfig()}
        title="Edit Covered Entity"
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
  };

  const renderConfigButton = () => {
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => handleConfig()}
        title="Client Configuration"
      >
        <HoverImage src={ConfigIcon} hoverSrc={ConfigIconHover} alt="" />
      </Button>
    );
  };

  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        {renderEditButton()}
        {/* {renderConfigButton(rowData)} */}
        {/* {renderCommentsButton(rowData)} */}
        {/* {renderViewButton(rowData)} */}
      </div>
    );
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleDeleteConfirmation = async () => {
    setisConfirm(!isConfirm);
  };
  const handleAuthorizeConfirmation = async () => {
    setisAuthorize(!isAuthorize);
  };
  const hasPermission = (code) => {
    return ModuleAccess("PCO", code);
  };
  const toggleAO = () => {
    setAuthorizeModal(!authorizemodal);
  };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };
  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const updateRowValue = (value, col, row) => {
    
    const tempRow = { ...row };
    tempRow[col] = value;
    rowForEdit = tempRow;
    if (EditData.length > 0) {
      for (var x in EditData) {
         if (EditData[x].poItemID == row.poItemID ) {
          if(col=="gpoPkgs"){
            EditData[x].gpoPkgs = value;
 
          }
          else{
            EditData[x].wacPkgs = value;
 
          }
         
        }
        // if (EditData[x].poItemID == row.poItemID ) {
        //   EditData[x].wacPkgs = value;
          
        // }
        
        else {
          EditData.push(rowForEdit);
        }
      }
    }
    else {
      EditData.push(rowForEdit);

    }
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
  
    return (
      <CellEditRender
      wacErr={wacErr}
      wacErrZero={wacErrZero}
      gpoErrZero={gpoErrZero}
        row={row}
        col={col}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        formatterType={formatterType}
        onChange={updateRowValue}
      />
    );
  };
  const handleFilterCancel = () => {
    refetch();
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      // setColFilters(colFilter);
    }
  };
  const cellRendererDollers = ({ totalPackages, wacPackages }) => {
    const wacPercentage = (wacPackages / totalPackages) * 100;
    if (wacPercentage > 30) {
      return "$$$$";
    } else if (wacPercentage >= 20 && wacPercentage <= 30) {
      return "$$$";
    } else if (wacPercentage >= 10 && wacPercentage < 20) {
      return "$$";
    } else {
      return "$";
    }
  };

  const toggleviewsugg = (rowdata) => {
    setSelectedRow(rowdata)
    setOpenViewSugg(!openviewsugg)

  }
const renderhyperlink = (rowdata)=>{
  return (
    <div>
    <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => toggleviewsugg(rowdata)}
                title='View Suggestions'

            >
                <HoverImage src={viewimage}
                    hoverSrc={viewimagehover}
                    alt='' />
            </Button>
            </div>
    // <span
    //     className='text-decoration-underline d-inline-block cursor-pointer'
    //      onClick={() => toggleviewsugg(rowdata)}
    // >
    //   {'View Suggestions'}
    // </span>
);
}

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
       cellRenderer: (rowData) => renderhyperlink(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "ordervalue",
      text: "Order Value",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.ordervalue),
    },
    {
      dataField: "itemNumber",
      text: "Item Number",
      sort: true,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.itemNumber),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "drugName",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugName),
    },
    {
      dataField: "package",
      text: "PackageSize",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.package),
    },
    {
      dataField: "manufacture",
      text: "Manufacturer",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.manufacture),
    },
    {
      dataField: "totalpkgs",
      text: "Total Ordered Packages",
      sort: false,
      width: 100,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (row) =>
        row.totalpkgs === 0.0 ? "0.00" : cellRendererCheck(row.totalpkgs),
      //cellRenderer: (row) => cellRendererCheck(row.totalpkgs),
    },
    {
      dataField: "accumulations340B",
      text: "340B Accumulations",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) =>
        row.accumulations340B === 0.0
          ? "0.00"
          : cellRendererCheck(row.accumulations340B),
      // cellRenderer: (row) => cellRendererCheck(row.accumulations340B),
    },
    {
      dataField: "pkg340B",
      text: "340B Pkgs",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) =>
        row.pkg340B === 0.0 ? "0.00" : cellRendererCheck(row.pkg340B),
      //cellRenderer: (row) => cellRendererCheck(row.pkg340B),
    },
    {
      dataField: "pricePkgs340B",
      text: "340B Price/Pack",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
    //   cellRenderer: (row) =>
    //     row.pricePkgs340B === null ? "$0.00" : currencyFormat(row.pricePkgs340B),
    //   //cellRenderer: (row) => currencyFormat(row.pricePkgs340B),
    // },
    cellRenderer:(row)=>cellRendererCheck(row.pricePkgs340B)
},
    {
      dataField: "total340BPrice",
      text: "Total 340B Price",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.total340BPrice === null
      //     ? "$0.00"
      //     : currencyFormat(row.total340BPrice),
      //cellRenderer: (row) => currencyFormat(row.total340BPrice),
      cellRenderer:(row)=>cellRendererCheck(row.total340BPrice)

    },
    {
      dataField: "gpoAccumulations",
      text: "GPO Accumulations",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) =>
        row.gpoAccumulations === 0.0
          ? "0.00"
          : cellRendererCheck(row.gpoAccumulations),
      //cellRenderer: (row) => cellRendererCheck(row.gpoAccumulations),
    },
    {
      dataField: "gpoPkgs",
      text: "GPO Pkgs",
      sort: false,
      width: 100,
      show: true,
      edit: showdata[0]?.gpoProhibitionFlag == "N" ? true : false,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row, col) =>row.gpoPkgs < 1 ? "0" : formatter(row, col,'number'),
      //cellRenderer: (row, col) => formatter(row, col),
      //cellRenderer: (row) => row.gpoPkgs === 0.0000 ? '0.00' : cellRendererCheck(row.gpoPkgs)
      //cellRenderer: (row) => cellRendererCheck(row.gpoPkgs),
    },
    {
      dataField: "gpoPricePkgs",
      text: "GPO Price/Pack",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.gpoPricePkgs === null ? "$0.00" : currencyFormat(row.gpoPricePkgs),
      cellRenderer:(row)=>cellRendererCheck(row.gpoPricePkgs)

      //cellRenderer: (row) => currencyFormat(row.gpoPricePkgs),
    },
    {
      dataField: "totalGPOPrice",
      text: "Total GPO Price",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.totalGPOPrice === null ? "$0.00" : currencyFormat(row.totalGPOPrice),
      cellRenderer:(row)=>cellRendererCheck(row.totalGPOPrice)

      //cellRenderer: (row) => currencyFormat(row.totalGPOPrice),
    },
    {
      dataField: "wacPkgs",
      text: "WAC Pkgs",
      sort: false,
      width: 100,
      show: true,
      edit: showdata[0]?.gpoProhibitionFlag == "Y" ? true  : false ,
      inputType: "text",
      hideColFilter: true,
      //cellRenderer: (row) => row.wacPkgs === 0.0000 ? '0.00' : formatter(row.wacPkgs)
      cellRenderer: (row, col) =>row.wacPkgs < 1 ? "0" : formatter(row, col,'number'),
    },
    {
      dataField: "wacPricePack",

      text: "WAC Price/Pack",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.wacPricePack === 0.0 ? "$0.00" : currencyFormat(row.wacPricePack),
      //cellRenderer: (row) => currencyFormat(row.wacPricePack),
      cellRenderer:(row)=>cellRendererCheck(row.wacPricePack)

    },
    {
      dataField: "totalWACPrice",
      text: "Total WAC Price",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.totalWACPrice === 0.0 ? "$0.00" : currencyFormat(row.totalWACPrice),
      //cellRenderer: (row) => currencyFormat(row.totalWACPrice),
      cellRenderer:(row)=>cellRendererCheck(row.totalWACPrice)

    },
    {
      dataField: "totalspend",
      text: "Total Spend",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) =>
      //   row.totalWACPrice === 0.0 ? "$0.00" : currencyFormat(row.totalspend),
      //cellRenderer: (row) => currencyFormat(row.totalWACPrice),
      cellRenderer:(row)=>cellRendererCheck(row.totalspend)

    },
    
  ];
  const cancelorder = async () => {
    debugger;
    handleDeleteConfirmation();
    setLoading(true);
    try {
      const { data1 } = await API.get(
        `SBTenant/${orgId.tenantID}/PurchaseOrder/orderReviewCancel/${showdata[0].poid}`,
        { hasDefaultURL: true }
      );

      // if (data1) {
        toast.success("Order Cancelled Succssfully");
        setkey("searchorder");
        // refetch(true);
        setLoading(false);

        setTableData([]);
        onReset(true);
        //toggle();
      // } else {
      // }
    } catch {
      setLoading(false);

    }
  };
  const authorizeorder = async () => {
    handleAuthorizeConfirmation();
    setLoading(true);
    try {
      const { data2 } = await API.get(
        `SBTenant/${orgId.tenantID}/PurchaseOrder/REvieworderauthorize/${showdata[0].poid}`,
        { hasDefaultURL: true }
      );
      setkey("searchorder");
      // refetch(true);
      setLoading(false);
      setTableData([]);
      // if (data2) {
      //   //toggle();
      // }
    } catch {setLoading(false);}
  };
  const saveUpdateRow = async () => {
    // if (checkvalidation(rowForEdit))
    // {
    //   return true;
    // }
    checkvalidation(rowForEdit)
    let ReviewEditList = [];
    let payload = {};
    let lst = {};
    for (var x in EditData) {
      delete EditData[x].isEdit;
    }
    payload.Wacpricelist = EditData;
    setLoading(true);
    try {
      const { data3 } = await API.post(
        `SBTenant/${orgId.tenantID}/PurchaseOrder/Update/`,
        payload,
        { hasDefaultURL: true }
      );
      // setTableData([]);
        
        editRow(false);
        refetch(true);
        setLoading(false);
        // setTableData(data3);
        // showdata([]);
      
    } catch {
      setLoading(false);
    }
  };
  const cellRenderLink = (rowData) => {
    // if (hasPermission('VWPO')) {
    return (
      <span
        className="text-decoration-underline d-inline-block cursor-pointer"
        onClick={() => handlePODetails(rowData)}
      >
        {rowData}
      </span>
    );
    // }
  };
  const handlePODetails = (row) => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails("OrderDetails");
    // setPORowData(row);
  };

  const editRow = (isEdit = true) => {
    if (isEdit == false) {
      setEditFlag(false);
    } else {
      EditData = [];
      setEditFlag(true);
    }
    let tempData = [...tableData];

    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setWACerr(false);
    setGPOerr(false);
    setWACerrZero(false);
    setGPOerrZero(false);
    //    setSelectedStatus('');
    updatedFields = {};
    //  tableDataBackup = tempData;
    setTableData(tempData);
  };
  return (
    <div>
       {/* <h5 className="f-16 text-primary font-weight-700 mt-2">
           Review Order Count ({totalitem})
            </h5>
            <hr/> */}
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
      > 
            {loading && <Loader opacity={0.02} color="black" />}

        <ReactStrapTable
          id="configuration-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          keytab={tabKey}
          data={tableData}
          columns={mainCol}
          // hasPagination
          filters={filters}
          //totalRecords={totalitem}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          onExport={onExport}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
                showtoggle={true}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
        />

        <div>
        <Drawer
        direction="end"
        isOpen={openviewsugg}
        toggle={toggleviewsugg}
        size="lg"
        title="Order List"
      >
       <ViewSuuestions toggleviewsugg={toggleviewsugg} selectedrow={selectedrow} />
      </Drawer>
          <Confirm
            isOpen={isConfirm}
            message=" Do you wish to cancel this order? If yes, these items
                          will not be sent to your vendor for processing. To
                          proceed click Ok"
            onToggle={handleDeleteConfirmation}
            onCancel={handleDeleteConfirmation}
            onContinue={cancelorder}
          />
          <Confirm
            isOpen={isAuthorize}
            message=" Do you wish to authorize the order?
Please Note : Once order is authorized, status cannot be changed.
To proceed click Ok."
            onToggle={handleAuthorizeConfirmation}
            onCancel={handleAuthorizeConfirmation}
            onContinue={authorizeorder}
          />
          <br></br>
          <Row className="d-flex" style={{ justifyContent: "flex-end" }}>
          <Col md="auto" className="" hidden={!(hasPermission('ED'))}>
              {/* <Button color="primary" className="" onClick={() => navigate(<SearchContainer/>)}>
              Back
            </Button> */}
              <Button
              
                color="primary"
                className="reset"
                onClick={handleDeleteConfirmation}
                hidden={!hasPermission("CO") || editFlag == true || tableData.length < 1}
              >
                <span className="right_5"><img src={cancel} alt="" /></span> Cancel Order
              </Button>
            
              <Button
                color="primary"
                hidden={editFlag == true || tableData.length < 1}
                className="reset"
                onClick={editRow}
              >
                <span className="right_5"><img src={edit} alt="" /></span> Edit Order
              </Button>
              <Button
                color="primary"
                //hidden={!(hasPermission('AO'))}
                hidden={editFlag == true || tableData.length < 1}
                className="search"
                onClick={handleAuthorizeConfirmation}
              >
                <span className="right_5"><img src={save} alt="" /></span> Authorize Order
              </Button>
              <Button
                hidden={!editFlag}
             
                    color="primary"
                className="search"
                onClick={saveUpdateRow}
              >
               <span className="right_5"><img src={save} alt="" /></span> Save
              </Button>
              <Button
              
              //hidden={!(hasPermission('ED'))}
             hidden={!editFlag}
                color="primary"
                className="reset"
                onClick={() => editRow(false)}
              >
                <span className="right_5"><img src={cancel} alt="" /></span> Cancel
              </Button>
            </Col>
            {/* 
            <Col hidden={!editFlag} style={{ float: "right" }}>
              <Button color="primary" onClick={saveUpdateRow}>
                Save
              </Button>
              <Button color="primary" onClick={() => editRow(false)}>
                Cancel
              </Button>
            </Col> */}
          </Row>
        </div>
      </div>

      {/* <div>
        <Modal isOpen={modal}>
          <ModalHeader toggle={toggle}>
            <h5 className="f-15 text-primary font-weight-700 mt-2">
              Cancel order{" "}
            </h5>
          </ModalHeader>
          <ModalBody>
            <Formik
              children={(props) => {
                return (
                  <div>
                    <Row>
                      <Col>
 
                        <FormGroup>
                          Do you wish to cancel this order? If yes, these items
                          will not be sent to your vendor for processing. To
                          proceed click Ok
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </ModalBody>
          <ModalFooter>
            <Button color="primary"style={{width:"78px"}}  onClick={()=>{cancelorder(); }}>
              Ok
            </Button>{" "}
            <Button color="primary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div> */}
    </div>
  );
};

export default ReviewPurchaseOrderTable;
